import { ethers } from "ethers";
import { toastFailed } from "../Config/BasicInfo";

export default async function GetChainId() {
  try {
    if (!window.ethereum) {
      toastFailed("Non-Ethereum browser detected. Please install MetaMask!");
      return false;
    }

    // Request account access properly
    await window.ethereum.request({ method: "eth_requestAccounts" });

    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const network = await provider.getNetwork();
    const chainId = network.chainId;

    console.log("Chain ID:", chainId);

    if (chainId === 56) {
      return true;
    } else {
      toastFailed("Please connect your wallet with BSC Mainnet");
      return false;
    }
  } catch (e) {
    toastFailed("Please connect your wallet with BSC Mainnet");
    console.error("Error getting chain ID:", e);
    return false;
  }
}
